import Repository from "./Repository"

const resource = "dovemedpost/"

export default {
  get(userId, userCicrleId) {
    return Repository.get(`${resource}?user_id=${userId}&user_circle_id=${userCicrleId}`)
  },

  getById(postId, circleId) {
    return Repository.get(`${resource}?id=${postId}&page_num=1&items=1&sort_by=-created_at&circle_id=${circleId}`)
  },

  getAllTypeById(idName, id, circleId) {
    return Repository.get(`${resource}?${idName}=${id}&page_num=1&items=1&sort_by=-created_at&circle_id=${circleId}`)
  },

  getAllTypeByIdForNoti(idName, id, circleId) {
    return Repository.get(`/notificationpost/?${idName}=${id}&page_num=1&items=1&sort_by=-created_at&circle_id=${circleId}`)
  },

  /**
   * Fetch Post comments
   *
   * @param Integer postId
   * @param Integer page
   * @param Integer limit
   */
  fetchPostComments(postId, page, limit, id) {
    const c_id = id ? "&id=" + id : ""
    page = id ? 1 : page
    limit = id ? 1 : limit
    return Repository.get(`/dovemedpostcomments/?page_num=${page}&items=${limit}&post_id=${postId}${c_id}`)
  },

  /**
   * Get all posts
   * @param Integer page
   * @param Integer limit
   */
  getAll(userId, circleId, page, limit, filters = "", searchKey) {
    const search = searchKey ? `&search=${searchKey}` : ""

    return Repository.get(`${resource}?circle_id=${circleId}&page_num=${page}&items=${limit}&sort_by=-created_at${search}${filters ? `&filters=${filters}` : ""}`)
  },

  getTags(search) {
    return Repository.get(`/tags/?page_num=1&items=10&search=${search}`)
  },

  /**
   * Create Post
   * @param Object payload
   */
  createPost(payload) {
    return Repository.post(`${resource}`, payload)
  },

  createQuestion(payload) {
    return Repository.post(`/askquestions/`, payload)
  },

  createPoll(payload) {
    return Repository.post(`/polls/`, payload)
  },

  createPressRelease(payload) {
    return Repository.post(`/pressrelease/`, payload)
  },

  // getPressRelease(circle, page = 1, limit = 10, user) {
  //   return Repository.get(`/pressrelease/?circle_id=${circle}&page_num=${page}&items=${limit}&user=${user}`);
  // },

  editPressRelease(id, payload) {
    return Repository.put(`/pressrelease/?id=${id}`, payload)
  },

  createJob(payload) {
    return Repository.post(`/job/`, payload)
  },

  // getJob(circle, page = 1, limit = 10, user) {
  //   return Repository.get(`/job/?circle_id=${circle}&page_num=${page}&items=${limit}&user=${user}`);
  // },

  editJob(id, payload) {
    return Repository.put(`/job/?id=${id}`, payload)
  },

  createEvent(payload) {
    return Repository.post(`/event/`, payload)
  },

  // getEvent(payload) {
  //   return Repository.get(`/event/`, payload);
  // },

  editEvent(id, payload) {
    return Repository.put(`/event/?id=${id}`, payload)
  },

  // Comments for Job / Event / Press
  getOtherComments(circle, page = 1, limit = 1, id, type, cid) {
    const c_id = cid ? "&id=" + cid : ""
    return Repository.get(`/${type}comments/?circle_id=${circle}&page_num=${page}&items=${limit}&${type}s_id=${id}${c_id}`)
  },

  // Job comment replies
  getJobReplies(page = 1, limit = 1, id) {
    return Repository.get(`/commentsjoblist/?page_num=${page}&items=${limit}&comment_id=${id}`)
  },

  // Event comment replies
  getEventReplies(page = 1, limit = 1, id) {
    return Repository.get(`/commentseventlist/?page_num=${page}&items=${limit}&comment_id=${id}`)
  },

  // Press comment replies
  getPressReplies(page = 1, limit = 1, id) {
    return Repository.get(`/commentspresslist/?page_num=${page}&items=${limit}&comment_id=${id}`)
  },

  getUserPolls(page = 1, items = 10, circle_id) {
    return Repository.get(`/pollsbyuser/?page_num=${page}&items=${items}&circle_id=${circle_id}`)
  },

  /**
   * Report Content
   * @param Integer postId
   * @param Object paylo
   */
  reportContent(postId, payload, type) {
    let url = ""
    switch (type) {
      case 1:
        url = "dovemedpost/?id="
        break
      case 2:
        url = "comments/?id="
        break
      case 3:
        url = "askquestions/?id="
        break
      case 5:
        url = "polls/?id="
        break
      case 12:
        url = "job/?id="
        break
      case 13:
        url = "event/?id="
        break
      case 14:
        url = "pressrelease/?id="
        break
    }
    return Repository.put(`${url}${postId}`, payload)
  },

  /**
   * Post Comment
   * @param Object payload
   * @param Integer circleId
   */
  postComment(payload, circleId) {
    return Repository.post(`comments/?circle_id=${circleId}`, payload)
  },

  /**
   * Save Reaction
   * @param Integer circleId
   * @param Object payload
   */
  saveReaction(circleId, payload) {
    return Repository.post(`/reactions/?circle_id=${circleId}`, payload)
  },

  /**
   * Bulk Share
   * @param Integer circleId
   * @param Object payload
   */
  bulkShare(circleId, payload) {
    return Repository.post(`/bulkshare/?circle_id=${circleId}`, payload)
  },

  userPollComments(pollId, page, limit, circleId, id) {
    const c_id = id ? "&id=" + id : ""
    page = id ? 1 : page
    limit = id ? 1 : limit
    return Repository.get(`/pollcomments/?page_num=${page}&items=${limit}&poll_id=${pollId}&circle_id=${circleId}${c_id}`)
  },

  deletePost(id, payload) {
    return Repository.put(`/dovemedpost/?id=${id}`, payload)
  },

  deletePoll(id, payload) {
    return Repository.put(`/polls/?id=${id}`, payload)
  },

  addChoice(payload) {
    return Repository.post(`/choices/`, payload)
  },

  editChoice(id, payload) {
    return Repository.put(`/choices/?id=${id}`, payload)
  },

  deleteChoice(id) {
    return Repository.delete(`/choices/?id=${id}`)
  },

  // deletePollsByUser(id, payload) {
  //   return Repository.put(`/pollsbyuser/?id=${id}`, payload);
  // }

  deleteActivityQuestion(id, payload) {
    return Repository.put(`/dovemedpost/?question_id=${id}`, payload)
  },

  deleteActivityPoll(id, payload) {
    return Repository.put(`/dovemedpost/?poll_id=${id}`, payload)
  },

  deleteQuestion(id, payload) {
    return Repository.put(`/askquestions/?id=${id}`, payload)
  },

  deleteActivityQuestion(id, payload) {
    return Repository.put(`/dovemedpost/?question_id=${id}`, payload)
  },

  getPinnedPosts(circle) {
    return Repository.get(`dovemedpinnedpost/?circle_id=${circle}&page_num=1&items=1`)
  },

  closePinnedPost(payload) {
    return Repository.post(`closepinnedpost/`, payload)
  },

  getWelcomePosts(circle) {
    return Repository.get(`dovemedwelcomepost/?circle_id=${circle}&page_num=1&items=1`)
  },

  getReactionsList(rOnType = 0, id = 0, reType, page = 1, size = 10, role = "", AnsReType = "") {
    const type = AnsReType ? "&type=" + AnsReType : ""
    const roleType = role ? "&role=" + role : ""
    const onType = rOnType ? "&reacted_on_type=" + rOnType : ""
    const recType = reType ? "&reaction_type=" + reType : ""
    return Repository.get(`listreactions/?page_num=${page}&items=${size}${type}${roleType}${onType}&reacted_on_id=${id}${recType}`)
  },

  parseLink(payload) {
    return Repository.post("/dovemedlinkparse/", payload)
  },
}



// WEBPACK FOOTER //
// ./src/repositories/postsRepository.js